import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder } from '@angular/forms';
import { BaseModalDirective } from '../../base-modal';
declare let gtag: Function;

@Component({
  selector: 'nh-id-verify-error',
  templateUrl: './id-verify-error.component.html',
  styleUrl: './id-verify-error.component.scss',
  standalone: false
})
export class IdVerifyErrorComponent extends BaseModalDirective implements OnInit {
  isMobileUser: boolean = false;
  constructor(
    protected modalRef: BsModalRef,
    protected builder: FormBuilder,
    protected router: Router
  ) {
    super(modalRef, builder);
  }

  ngOnInit(): void {
    this.isMobileUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  }

  onReturnToVerify(): void {
    this.hide(true);
  }

  onApplyNow(): void {
    this.hide(true);
    sessionStorage.setItem("appType", "AFB");
    this.router.navigateByUrl("/application/" + "NEW");
  }

  onGoToDashboard(): void {
    this.hide(true);
    gtag('event', 'ridp_er_cd', {
      'event_category': 'ridp_identity_verification',
      'event_label': 'continue_to_dashboard'
    });
    this.router.navigate(['/user-profile', 'benefit-dashboard']);
  }
}
